// extracted by mini-css-extract-plugin
module.exports = {"container":"genericModalEntityContact_container__2YK5y","newcontact":"genericModalEntityContact_newcontact__2akgy","btn_create":"genericModalEntityContact_btn_create__1UvZQ"};